module.exports = __webpack_public_path__ + "img/img_level_7.d85abaae.png";